
export enum TipoEntryFormsEnum {
  Texto = 'Texto',
  Inteiro = 'Inteiro',
  Decimal = 'Decimal',
  Moeda = 'Moeda',
  Data = 'Data',
  Hora = 'Hora',
}
